import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import Navigation from '../Navigation';
import Carousel from '../Carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faStar } from '@fortawesome/free-solid-svg-icons'
import logo from '../../images/new_logo.svg';
import loading from '../../images/loading.png';
import { isNotEmpty } from "../../util/user";
import renderIf from "render-if";
import { faLinkedin, faFacebook, faAngellist, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import Helmet from "react-helmet";

export default class FullListing extends React.Component {
  constructor(props) {
    super(props);
    let listing;
    let listingId;
    let routed;
    let keysLength = Object.keys(props).length;

    if (keysLength === 0) {
      listing = undefined;
      routed = false;
      listingId = undefined;
    } else {
      if (props.match && props.match.path == "/communities/:id") {
        listing = undefined;
        routed = true;
        listingId = props.match.params.id;
      } else {
        listing = props.listing;
        routed = false;
        listingId = window.location.pathname;
      }
    }

    this.state = {
      mounted: false,
      editView: false,
      listing: listing,
      listingId: listingId,
      routed: routed,
      loading: true,
      propertyImages: [],
      errorMessage: undefined,
      showModal: false,
      savedListing: false,
      email: "",
      fullName: "",
      phone: "",
      notifyMessage: undefined
    }

    this.viewListing = this.viewListing.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.updateFullName = this.updateFullName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.hideMessageCtn = this.hideMessageCtn.bind(this);
  }

  hideMessageCtn() {
    this.setState({
      notifyMessage: undefined
    });
  }

  updateEmail(e) {
    const state = this;

    this.setState({
      email: e.target.value
    })
  }

  updatePhone(e) {
    const state = this;

    this.setState({
      phone: e.target.value
    })
  }

  updateMessage(e) {
    const state = this;

    this.setState({
      message: e.target.value
    })
  }

  updateFullName(e) {
    const state = this;

    this.setState({
      fullName: e.target.value
    })
  }

  viewListing(id) {
    const listingID = id !== undefined ? id : this.state.listingId;
    const state = this;

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'GET',
      headers: myHeaders
    };

    var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api${listingID}`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      let community = content.community;

      state.setState({
        listing: community,
        listings: content.listings,
        propertyImages: [],
        mounted: true,
        loading: false
      });

      return content;
    });
  }

  componentDidMount() {
    this.viewListing();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match !== undefined) {
      if(this.props.match.params.id !== nextProps.match.params.id) {
        this.viewListing(nextProps.match.params.id)
      }
    }
  }

  changeImage(image) {
    this.setState({currentImage: image.Image})
  }

  sendForm() {
    const state = this;

    let values = {};
    values = Object.assign({}, values, {
      message: this.state.message,
      phone: this.state.phone,
      email: this.state.email,
      full_name: this.state.fullName,
    });

    (async () => {
      const token = localStorage.getItem("auth_token");
      var myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      });

      var myInit = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(values)
      };
      var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/general_messages/`, myInit);

      const rawResponse = await fetch(myRequest)
      const content = await rawResponse.json();

      state.setState({
        notifyMessage: "Successful message. We will contact you shortly! :)"
      });

      setTimeout(() => {
        state.setState({
          notifyMessage: undefined
        })
      }, 7000)

      return content;
    })();
  }

  addDefaultSrc(ev) {
    ev.target.src = logo;
  }

  render() {
    let listing = this.state.listing || undefined;
    const q = listing ? encodeURIComponent(`${listing.title} Ontario Canada`) : ""
    const qstring = `https://www.google.com/maps/embed/v1/place?q=${q}&key=AIzaSyAtkp9JV5_7WHFm6TatGKCLG8JJEEUMCHA`
    const currentImage = listing ? this.state.currentImage : ""

    const notify = this.state.notifyMessage;
    let notifyDetail = <div></div>

    if (notify !== undefined) {
        notifyDetail = <div onClick={this.hideMessageCtn} className="notification-ctn notify">
          {notify}
        </div>
    }

    let titleLink = `/browse`
    if (listing && listing.title) {
      titleLink = `/browse?title=${listing.title}`
    }

    let communities = {
      "Ancaster" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.shawnpalmer.ca%2Fimages%2Fcontent%2FAncaster-Ontario-street-view.jpg&f=1&nofb=1",
        "description" : `Ancaster is an affluent community situated just West of Hamilton off of highway 403. When compared with Burlington, Oakville and Toronto this area offers exceptional housing affordability which explains why buyers from these communities are migrating to Ancaster. Located on the Niagara Escarpment the natural geography of Ancaster is absolutely breathtaking. It features Tiffany Falls Conservation Area along numerous hiking trails including the Heritage and Bruce Trails. Also, Ancaster Village is a highly walkable area with several quaint shops, restaurants and historic buildings. Ancaster still offers a small town feel within an urban setting.`,
        "parks" : ["Jerseyville Park", "Tiffany Falls Conservation Area", "Hamilton Golf and Country Club"],
        "rec" : ["Ancaster Village", "Ancaster Rotary Centre"],
        "schools" : ["Rousseau Elementary School", "St. Joachim Catholic Elementary School", "Ancaster Senior Public School", "Fessenden Elementary School", "Bishop Tonnos Catholic Secondary School"]
      },
      "Brantford" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.narcity.com%2Fu%2F2018%2F04%2F18%2F25877367f1ed5beec4bafbbf2a2c5edf9474feb3.jpg_1200x630.jpg&f=1&nofb=1",
        "description" : ``,
        "parks" : [],
        "rec" : [],
        "schools" : []
      },
      "Burlington" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.mcsrealestatewebsites.com%2FAssets%2FNeighbourhoods%2Fburlington-2.jpg&f=1&nofb=1",
        "description" : `Burlington has developed from a quiet bedroom community to a savvy, revitalized waterfront city. Strategically located in the Greater Toronto Area (GTA), Burlington offers a quality of life that is second to none with great schools, shopping, dining, recreational facilities, parkland, festivals and night life all available within the city. MoneySense, a leading lifestyle and investment magazine, has named Burlington the #1 mid-sized city in Canada to live. The lake is accessible to all with Spencer Smith Park being the main access point. Some of the city’s attractions include Canada’s Largest Ribfest, the world-renowned Sound of Music Festival, the Burlington Performing Arts Centre, the Burlington Art Centre, and Spencer Smith Park, all located near in the downtown core. Additionally, the city attracts hikers, birders and nature lovers to the stunning Royal Botanical Gardens located on the border with Hamilton. The Gardens are in close proximity to a part of the Niagara Escarpment in the north end of the city and includes the Iroquoian section of the Bruce Trail. Other fantastic events to enjoy in Burlington each year include Art in the Park, Lakeside Festival of Lights, and the Burlington Jazz’n Blues Festival.`,
        "parks" : ["Lyon’s Park", "Coronation Park", "Leighland Park", "Spencer Smith Park"],
        "rec" : ["Brant Street", "Waterfront"],
        "schools" : ["Halton District School Board", "Halton Catholic District School Board", "Blyth Academy Burlington"]
      },
      "Dundas" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fimages.dailyhive.com%2F20170127065907%2FTravis-Singleton-%254020two19-Photography2.jpg&f=1&nofb=1",
        "description" : `Nestled in a valley (hence the term Dundas Valley) below the Niagara Escarpment Dundas is a terrific bedroom community. Like Ancaster, Dundas offers a mix of newer housing development and older more mature areas including Downtown Dundas. Downtown Dundas has that "old town feel" and is a very walkable area featuring many quaint shops, restaurants, an Art Gallery and has even been the site for major film production.`,
        "parks" : ["Spencer Creek", "Dundas Driving Park", "Olympic Sports Park"],
        "rec" : ["Rail Trail", "Dundas Valley Golf and Curling Club", ],
        "schools" : ["Dundana Elementary School", "Dundas Valley Montessori School", "Yorkville Elementary School", "St. Augustine Catholic Elementary School", "Dundas Central Elementary School"]
      },
      "Flamborough" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.realtor.ca%2Flisting%2FTS636959526321700000%2Freb14%2Fhighres%2F6%2Fh4056186_2.jpg&f=1&nofb=1",
        "description" : `With more than 15 communities, each with their own character and appeal, Flamborough has been called a genuine community of communities. Extending 191 square miles, Flamborough includes urban Waterdown, as well as more rural areas such as Greensville. It is surrounded by conservation and recreation areas and offers year-round activities ranging from cross-country skiing in winter to boating and swimming in the summer. Flamborough is a community that cares, with countless service organizations, youth and seniors activities, and sports and recreation programs galore. Flamborough Community Information Services, which gathers together all services available to the community, is celebrating its 30th anniversary. The African Lion Safari is one of the Ontario’s key tourist attractions and opened here in 1969 to offer an animal-friendly take on the traditional zoo. As the Safari literature explains, animals roam free and visitors are caged! They now have more than 1,000 animals representing 100-plus species and have bred 50 species that are considered endangered or threatened. Flamborough also is home to Flamboro Downs raceway and casino, with top-name attractions, evening and daytime races and more than 750 slot machines.`,
        "parks" : ["Flamborough Park"],
        "rec" : ["Casino"],
        "schools" : ["Hamilton Wentworth District School Board", "Hamilton Wentworth Catholic District School Board"]
      },
      "Grimsby" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fpostmediatorontosun.files.wordpress.com%2F2018%2F02%2Fcover-image-main-street-and-ontario-street-cropped.jpg&f=1&nofb=1",
        "description" : `Grimsby is rich in history and small-town charm. It is a destination spot for visitors year-round, with a vibrant arts and culture scene, ample recreation opportunities, and a wonderful selection of shopping and dining in stunning natural surroundings. Nestled between beautiful Lake Ontario and the picturesque Niagara Escarpment, Grimsby has plenty to offer if you love the out of doors! Hiking, swimming, ice skating, picnics, fishing, birding, and beachcombing.`,
        "parks" : ["Beamer Memorial Conservation Area", "Centennial Park", "Forty Creek Park / 1812 Peace Garden", "Peach King Recreation Centre"],
        "rec" : ["Coronation Park & Grimsby Lions Community Pool", "Fifty Point Conservation Area"],
        "schools" : ["Grimsby Secondary School"]
      },
      "Hamilton" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2F1%2F11%2FNorthEndHamilton.JPG%2F1200px-NorthEndHamilton.JPG&f=1&nofb=1",
        "description" : `Hamilton is a community of rich cultural heritage, home to both natural and man-made wonders. Although its history goes back much further, the city was founded shortly after the war of 1812 by George Hamilton, a merchant, soldier and politician. It has a long history of hard work and ingenuity, and while it has changed and grown significantly over the past few centuries, the city has not lost its down-to-earth and spirited attitude towards life.`,
        "parks" : ["Spencer Gorge Wilderness Area", "Dundas Valley", "RGB Cootes Paradise Sanctuary"],
        "rec" : ["McMaster University", "James Street"],
        "schools" : ["Hamilton Wentworth District School Board", "Hamilton Wentworth Catholic District School Board", "Columbia International College", "McMaster University"]
      },
      "Niagara" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1",
        "description" : ``,
        "parks" : [],
        "rec" : [],
        "schools" : []
      },
      "Oakville" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fplumber.ca%2Fwp-content%2Fuploads%2F2013%2F06%2Fo-OAKVILLE-ONTARIO-facebook.jpg&f=1&nofb=1",
        "description" : `This impressive lakeside community within the Greater Toronto Area (GTA) is known as one of the most coveted residential and business centres in Ontario. Oakville enjoys safe neighbourhoods and quality schools, including a Sheridan College campus, as well as a full-service community hospital and a thriving and diversified economic base – all the while maintaining a small-town atmosphere. The town is well connected in terms of transportation: it’s just under half an hour to Toronto, Hamilton, and Pearson International Airport. Oakville has two GO Transit train stations and Oakville Transit provides local transportation that will get you where you need to go.`,
        "parks" : ["Village Wood Park", "Shell Park", "Bronte Bluff’s Park"],
        "rec" : ["Glen Abbey Golf"],
        "schools" : ["Halton District School Board", "Halton Catholic District School Board"]
      },
      "Stoney Creek" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fvignette.wikia.nocookie.net%2Fprowrestling%2Fimages%2F7%2F79%2FStoney_Creek%252C_ON.jpg%2Frevision%2Flatest%3Fcb%3D20150104013334&f=1&nofb=1",
        "description" : `Historic Stoney Creek has a long and honourable provenance and is one of the oldest communities in the City of Hamilton. Settlements were first established primarily by United Empire Loyalists in the late 1700s, and residents annually celebrate a key battle from the War of 1812, with re-enactments and tours of the Battle of Stoney Creek National Historical Site. Now one of the fastest-growing areas within the city, industry and housing development are attracted by its central location close to the lake. Upper Stoney Creek also includes a portion of the Niagara Escarpment, with access to the beauty of nearby parks and conservation areas as well as the many urban amenities offered both above and below the escarpment. There is a strong tradition of innovation and entrepreneurship in Stoney Creek. The Stoney Creek Chamber of Commerce, formed in 1950, has more than 400 members and a strong voice on the issues impacting the business community. An unusual celebration was born in Stoney Creek in 1969, when the community adopted the idea of celebrating Canada’s new maple leaf flag as a focus for community activities. Held a month before Canada Day, it includes an annual parade and festival. It focuses on a combination of pride in the Canadian flag and local civil spirit, as seen in the honouring of the famous 1813 Battle of Stoney Creek. Today, Stoney Creek retains its historic identity, while serving as one of the most populous and fastest-growing sectors in Hamilton.`,
        "parks" : ["Bruce Trail", "Fifty Point Conservation Area", "Niagara Escarpment"],
        "rec" : ["Battlefield House", "Eastgate Square", "Fiesta Mall", "Niagara Winery Region"],
        "schools" : ["Hamilton Wentworth District School Board", "Hamilton Wentworth Catholic District School Board"]
      },
      "Waterdown" : {
        "img" : "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1",
        "description" : `The quiet but rapidly-growing village of Waterdown was established in the late 1830s boasting Victorian style houses, boutique shopping and mature tree-lined streets. Perched on the edge of the picturesque Niagara Escarpment, this community is home to many historical buildings, which remain from the founding of the town. A nature-lover’s delight, Waterdown is steps to the Bruce Trail.`,
        "parks" : ["Waterdown Memorial Park", "Sealey Park", "Clappison Woods"],
        "rec" : ["Rockcliffe Trails", "Olympia Village Park & Campground"],
        "schools" : ["Hamilton Wentworth District School Board", "Hamilton Wentworth Catholic District School Board"]
      },
    }


    let communityChosen = communities["Ancaster"];
    let mailLink;
    let twittertext;
    let facebooktext;
    let linkedintext;

    if (listing !== undefined) {
      communityChosen = communities[listing.title] || communities["Ancaster"];
      mailLink = `mailto:example@gmail.com?subject=${listing.title}body=${window.location.href}`
      twittertext = `https://twitter.com/intent/tweet?text=${window.location.href}`
      facebooktext = `https://www.facebook.com/sharer.php?u=${window.location.href}`
      linkedintext = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`
    }

    return (
      <div className="full-job-ctn">
        <div className="job-outline">
          {!listing &&
            <div id="loading-state"><img src={loading} /></div>
          }

          {listing && (
            <div className="full-job-details-stacked listing-page">
              <Helmet>
                <title>{'Hamilton Homes - ' + listing.title}</title>
                <meta name="description" content="Explore the beautiful GTHA communities and all we can offer you with our local expertise of the area!"/>
                <meta name="keywords" content="buying,communities,ancaster,stoney creek,niagara,waterdown, grimsby, burlington, Flamborough, dundas, brantford, amilton,homes,for,sale,niburski,search,condos,luxury,business"/>

                <meta property="og:url" content="https://besthamiltonhouses.com/communities"/>
                <meta property="og:title" content={"Hamilton Homes - " + listing.title}/>
                <meta property="og:description" content="Explore the beautiful GTHA communities and all we can offer you with our local expertise of the area!"/>
              </Helmet>

              <div className="heading">
                <h2>{listing.title}</h2>
              </div>

              <div className="images">
                <div className="current-image">
                  <img onError={this.addDefaultSrc} src={communityChosen.img}/>
                </div>

                <div className="social-media">
                  <a href={twittertext} target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a href={linkedintext} target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a>
                  <a href={facebooktext} target="_blank"><FontAwesomeIcon icon={faFacebook} /></a>
                  <a href={mailLink} target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a>
                </div>
              </div>

              <div className="listing-info">
                <div className="content">
                  <div className="left">
                    <iframe width="500" height="500" frameBorder="0" src={qstring}></iframe>

                    <h2 className="heading">
                      <Link className="black-font" to={titleLink}>Get {listing.title} Listings</Link>
                    </h2>
                  </div>

                  <div className="right">
                    <section>
                      <h2 className="small-heading">{listing.title}</h2>

                      <div className="public-remarks">
                        {communityChosen.description}
                      </div>
                    </section>

                    <section>
                      <h2 className="small-heading">Schools</h2>
                      {communityChosen.schools.map((school) =>
                        <h3 key={school}>{school}</h3>
                      )}
                    </section>

                    <section>
                      <h2 className="small-heading">Recreation</h2>
                      {communityChosen.rec.map((rec) =>
                        <h3 key={rec}>{rec}</h3>
                      )}
                    </section>

                    <section>
                      <h2 className="small-heading">Parks</h2>
                      {communityChosen.parks.map((park) =>
                        <h3 key={park}>{park}</h3>
                      )}
                    </section>
                  </div>
                </div>
              </div>

              <div className="contact-form">
                <h2 className="small-heading centered">Contact Us About {listing.title}</h2>

                <div className="inputs">
                  <div className="input-form">
                    <div className="label">
                      Full Name
                    </div>

                    <input onChange={this.updateFullName.bind(this)} value={this.state.fullName} className="input"></input>
                  </div>

                  <div className="input-form half-form first-form">
                    <div className="label">
                      Email address
                    </div>

                    <input onChange={this.updateEmail.bind(this)} value={this.state.email} className="input"></input>
                  </div>

                  <div className="input-form half-form">
                    <div className="label">
                      Phone
                    </div>

                    <input onChange={this.updatePhone.bind(this)} value={this.state.phone} className="input"></input>
                  </div>

                  <div className="input-form">
                    <div className="label">
                      Message
                    </div>

                    <textarea onChange={this.updateMessage.bind(this)} value={this.state.message} className="input"></textarea>
                  </div>

                  <div onClick={() => this.sendForm()} className="button">
                    Send
                  </div>
                </div>
              </div>

              <div className="full-listing-idx">
                <img src="https://s3.amazonaws.com/staticos.idxbroker.com/mls-logos/b579-logoURL-idxsandbox" alt="" />

                <div className="text">
                  © 2019 REALTORS® Association of Hamilton-Burlington (RAHB). All rights reserved. The data relating to real estate for sale on this web site comes in part from the Internet Data Exchange Program of RAHB. Real estate listings held by IDX Brokerage firms other than Prosession Homes are marked with the Internet Data Exchange logo or the Internet Data Exchange thumbnail logo and detailed information about them includes the name of the listing Brokers. Information provided is deemed reliable but not guaranteed.
                </div>

                <br />
                <br />
              </div>
            </div>
          )}

          {notifyDetail}
        </div>
      </div>
    )
  }
}
